// MILES Business Hub — styles partagés (sobres, palette MILES)
export const inputCls = "h-11 w-full rounded-xl border border-ink/10 bg-white px-3.5 text-sm text-ink placeholder:text-slate/50 outline-none transition-all focus:border-miles focus:ring-4 focus:ring-miles/10";
export const selectCls = inputCls;
export const labelCls = "mb-1 block text-xs font-medium text-slate";
export const cardCls = "rounded-2xl border border-ink/[0.07] bg-white";
export const btnPrimary = "inline-flex h-11 items-center justify-center gap-2 rounded-xl bg-miles px-5 text-sm font-semibold text-white shadow-[0_4px_14px_rgba(36,87,255,0.25)] transition-all hover:bg-miles-dark active:scale-[0.98] disabled:opacity-40 disabled:pointer-events-none";
export const btnSecondary = "inline-flex h-11 items-center justify-center gap-2 rounded-xl border border-ink/10 bg-white px-5 text-sm font-semibold text-ink transition-colors hover:border-miles/35 hover:text-miles";
export const btnGhost = "inline-flex h-9 items-center gap-1.5 rounded-lg px-3 text-xs font-semibold text-slate transition-colors hover:bg-ink/[0.05] hover:text-ink";

export const formatChf = (v) =>
  v === null || v === undefined ? "—" : `CHF ${Number(v).toLocaleString("fr-CH", { minimumFractionDigits: 2 })}`;

export const MISSION_TYPE_ICONS = {
  transfer: "→", airport: "✈", private_aviation: "✈", train: "◉", hourly: "◷",
  multi_stop: "⋯", group: "👥", event: "★", shuttle: "↔", luggage: "◈",
  delivery: "▣", recurring: "↻", custom: "+",
};

export const STATUS_TONE = {
  confirmed: "bg-miles-ice text-miles",
  in_progress: "bg-sky-50 text-sky-700",
  completed: "bg-emerald-50 text-emerald-700",
  cancelled: "bg-ink/[0.05] text-slate",
  to_quote: "bg-amber-50 text-amber-700",
  pending: "bg-amber-50 text-amber-700",
  available: "bg-emerald-50 text-emerald-700",
  paid: "bg-emerald-50 text-emerald-700",
  adjusted: "bg-amber-50 text-amber-700",
  created: "bg-miles-ice text-miles",
};

export function Badge({ tone, children, testId }) {
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-medium ${STATUS_TONE[tone] || "bg-ink/[0.05] text-slate"}`}>
      {children}
    </span>
  );
}
